import { SkinDate } from "../skin-date"
import { TranslatedString } from "../translated-string"

export const ITEM_SCHEMAS = [
    "conditioningItemSchema",
    "identificationItemSchema",
    "descriptionItemSchema",
    "juridicalItemSchema",
    "conservationItemSchema",
    "stateItemSchema",
    "locationItemSchema",
    "conditioningItemSchema",
    "linkItemSchema",
    "insuranceEstimationItemSchema",
    "historyItemSchema",
    "communicabilityItemSchema",
    "juridicalDepositedObjectsSchema",
    "juridicalAffectedObjectsSchema",
    "statusesSchema",
    "contextualNotesSchema",
    "hasExpression",
    "recordPermission",
    "recolementItemSchema",
    "hasChildren",
    "lastConditionReport",
    "isUsedInFileRetentionProject",
    "postAuditRecordItemSchema",
    "calculatedDimension",
]

export const PATRIMONIAL_ITEM_SCHEMAS = ITEM_SCHEMAS.concat([
    "safetyPlanSchema",
    "versionTitle",
])

export const MUSEUM_ITEM_SCHEMAS = PATRIMONIAL_ITEM_SCHEMAS.concat([
    "discoveryContextMuseumItemSchema",
    "itemSetSchema",
    "modeUniverseSchema",
    "federatedSchema",
    "nationalExportSchema",
    "ethnologyFieldSchema",
    "linkMuseumItemSchema",
])

export const PHYSICAL_MUSEUM_ITEM_SCHEMAS = MUSEUM_ITEM_SCHEMAS.concat([
    "linkToManifestation",
    "schemaSeydoux",
    "naturalHistorySchema",
])

export interface Item {
    id: string
    
    associatedMedias: any
    entityType?: string
    stateItemSchema: any
    type: string // TODO pass as optional type?: string
    linkToManifestation: {
        referentManifestation: string
    },
    institutionCreation: string,
    conditioningItemSchema?: {
        actualContainer?: ActualContainerItem[]
    }

    identificationItemSchema?: IdentificationItemSchemaResource,
    descriptionItemSchema?: DescriptionItemSchemaResource,
    juridicalItemSchema?: JuridicalItemSchemaResource,
    /*conservationItemSchema?: ConservationItemSchemaResource,
    stateItemSchema?: StateItemSchemaResource,
    locationItemSchema?: LocationItemSchemaResource,
    conditioningItemSchema?: ConditioningItemSchemaResource,
    linkItemSchema?: LinkItemSchemaResource,
    insuranceEstimationItemSchema?: InsuranceEstimationItemSchemaResource,
    historyItemSchema?: HistoryItemSchemaResource,
    communicabilityItemSchema?: CommunicabilityItemSchemaResource,
    juridicalDepositedObjectsSchema?: JuridicalDepositedObjectsSchemaResource,
    juridicalAffectedObjectsSchema?: JuridicalAffectedObjectsSchemaResource,
    statusesSchema?: StatusesSchemaResource,
    contextualNotesSchema?: ContextualNotesSchemaResource,
    hasExpression?: boolean,
    recordPermission?: ItemPermissionResource,
    recolementItemSchema?: RecolementItemSchemaResource,
    hasChildren?: boolean,
    lastConditionReport?: string,
    isUsedInFileRetentionProject?: ItemIsUsedInFileRetentionProject,
    modelTitle?: string,
    isDefaultModel?: boolean,
    postAuditRecordItemSchema?: PostAuditRecordItemSchemaResource,
    calculatedDimension?: CalculatedDimensionResource,*/
}

export interface IdentificationItemSchemaResource {
    identifiers?: IdentifierResource[],
    barCodes?: TranslatedString,
    otherIdentifiers?: OtherIdentifierResource[],
    internalMarking?: InternalMarkingResource | null 
}

export interface InternalMarkingResource {
    marked?: boolean | null
    completedOn?: SkinDate | null
    completedBy?: string | null
    markingTechnique?: TranslatedString | null
    furtherInformation?: TranslatedString | null 
}

export interface IdentifierResource {
    principal?: boolean
    identifier?: string
    idType?: TranslatedString
    notes?: TranslatedString
    isAccesionNumber?: boolean
}

export interface OtherIdentifierResource {
    identifier?: TranslatedString
    identifierType?: TranslatedString
    precision?: TranslatedString
}

export interface DescriptionItemSchemaResource {
    itemType?: string[]
    designations?: DesignationResource[]
    manifoldsDiscoverers?: ManifoldDiscovererResource[]
    registrations?: RegistrationResource[]
    materialDescription?: TranslatedString
    otherDescriptions?: OtherDescriptionResource[]
    integrationContextInCollections?: TranslatedString
    particularities?: ParticularitiesResource[]
    rarityInCollection?: TranslatedString[]
    interestOfObjectInCollection?: TranslatedString[]
    numberOfElements?: TranslatedString
    numberOfObjects?: TranslatedString
    commentaries?: CommentarieResource[] 
    collections?: CollectionsResource[]
    analysis?: AnalysisResource[]
    elementsDescriptions?: ElementsDescriptionResource[]
    elementNumber?: ElementNumberResource
    authenticities?: AuthenticityResource[]
    rarities?: RarityResource[]
    reproductions?: ReproductionResource[]
    recordPattern?: RecordPatternItemResource
    contactItems?: ContactItemResource[]
    numberOfCopy?: NumberOfCopyResource
    medium?: ItemMediumResource[] | null
    isParentItem?: boolean
}

export interface ItemMediumResource {
    medium?: string | null 
    precision?: TranslatedString | null 
}

export interface DesignationResource {
    designation?: TranslatedString
    designationType?: TranslatedString
    precision?: TranslatedString
}

export interface ManifoldDiscovererResource {
    name?: string
    functions?: string[]
    precision?: TranslatedString
}

export interface RegistrationResource {
    registrationTypes?: string[]
    emplacements?: string[]
    author?: string
    languages?: string[]
    registrationTranscription?: TranslatedString
    translation?: TranslatedString
    transliteration?: TranslatedString
    precisions?: TranslatedString[]
    alphabet?: string[]
    notes?: TranslatedString[]
    associatedMarkSignature?: string
    inscriptionTechniques?: Array<string> 
}

interface OtherDescriptionResource {
    descriptionType?: TranslatedString
    description?: TranslatedString
    precision?: TranslatedString
    notes?: TranslatedString[]
}

interface ParticularitiesResource {
    typeOfParticularitie?: string
    description?: TranslatedString
    notes?: TranslatedString[]
}

interface CommentarieResource {
    typeOfCommentarie?: TranslatedString
    commentarie?: TranslatedString
}

interface CollectionsResource {
    collection?: string
    precision?: TranslatedString
}

interface AnalysisResource {
    analysisMethod?: string
    results?: ResultsResource[]
    precision?: TranslatedString
}

interface ResultsResource {
    analysisType?: string
    result?: TranslatedString
    precision?: TranslatedString
}

interface ElementsDescriptionResource {
    elementType?: TranslatedString
    elementDescription?: TranslatedString
    number?: TranslatedString
    precision?: TranslatedString
}

interface ElementNumberResource {
    number?: TranslatedString
    totalElement?: TranslatedString
    precision?: TranslatedString
}

interface AuthenticityResource {
    authenticityLevel?: TranslatedString
    precision?: TranslatedString
}

interface RarityResource {
    rarityLevel?: TranslatedString
    precision?: TranslatedString
}

interface ReproductionResource {
    nature?: TranslatedString
    description?: TranslatedString
    linkedObject?: string
    precision?: TranslatedString
    notes?: TranslatedString[]
}

interface RecordPatternItemResource {
    isPattern?: boolean
    title?: TranslatedString 
}

interface ContactItemResource {
    name?: string
    address?: string
    functions?: string[]
    precision?: TranslatedString
}

interface NumberOfCopyResource {
    copyNumber?: TranslatedString
    precision?: TranslatedString
}

interface JuridicalItemSchemaResource {
    propertyType?: string
    protection?: ProtectionResource[]
    opinionOfScientificInstances?: OpinionOfScientificInstancesResource[]
    acquisitionModes?: AcquisitionModeResource[]
    buyingPrice?: BuyingPriceResource
    affectedDateToMuseum?: AffectedDateToMuseumResource
    firstDateOfPresence?: FirstDateOfPresenceResource
    ownerInstitutions?: OwnerInstitutionResource[]
    assigningEstablishment?: string
    depositedEstablishments?: DepositedEstablishmentResource[]
    donorsTestators?: ItemDonorTestatorResource[]
    sellerAndSalesInformation?: ItemSellerAndSalesInformationResource[]
    oldAffiliations?: OldAffiliationResource[]
    oldDepositories?: OldDepositoryResource[]
    disappearanceDates?: DisappearanceDateResource[]
    recoverDate?: RecoverDateResource
    removedObject?: boolean
    destroyedObject?: boolean
    rightItems?: RightItemResource[]
    itemSellingPrices?: ItemSellingPriceResource[]
    informationRadiations?: InformationOnDeaccessioningResource
    subInventoryRegisters?: SubInventoryRegisterResource[]
    taxationItems?: TaxationItemResource[]
    sourceReferenceItems?: SourceReferenceItemResource[]
}

interface ProtectionResource {
    protectionType?: string[]
    date?: DateProtectionResource[]
    notes?: TranslatedString[]
    periods?: PeriodProtectionResource[]
    precision?: TranslatedString
}

interface DateProtectionResource {
    skinDate?: SkinDate
    dateQualification?: string
}

interface PeriodProtectionResource {
    period?: string
    qualifier?: string
}

interface OpinionOfScientificInstancesResource {
    date?: SkinDate
    opinion?: TranslatedString
    precision?: TranslatedString
    notes?: TranslatedString[]
    competentInstances?: string[]
}

interface AcquisitionModeResource {
    acquisitionMode?: string
    precision?: TranslatedString
}

interface BuyingPriceResource {
    prices?: PriceResource[]
    publicContestInformation?: TranslatedString
    privateContestInformation?: TranslatedString
    otherPrecision?: TranslatedString
    subsidizedPurchase?: boolean
}

interface PriceResource {
    amount?: string
    currency?: string
    precision?: TranslatedString
    priceDates?: PriceDateResource[]
}

interface PriceDateResource {
    date?: SkinDate
    qualifier?: string
}

interface AffectedDateToMuseumResource {
    affectedDate?: SkinDate
    affectedPeriod?: string
    precision?: TranslatedString
}

interface FirstDateOfPresenceResource {
    date?: SkinDate
    precision?: TranslatedString
}

interface DepositedEstablishmentResource {
    establishment?: string
    precision?: TranslatedString
    location?: string
    notes?: TranslatedString[]
}

interface ItemDonorTestatorResource {
    donorTestator?: string
    role?: string
    precision?: TranslatedString
    notes?: TranslatedString[]
}

interface ItemSellerAndSalesInformationResource {
    titleOfSale?: TranslatedString
    saleLocation?: TranslatedString
    saleEstablishment?: string
    seller?: string
    saleDate?: SkinDate
    objectNumberInSale?: TranslatedString
    precision?: TranslatedString
    notes?: TranslatedString[]
}

interface OldAffiliationResource {
    oldOwner?: string
    propertyType?: string
    places?: String[]
    precision?: TranslatedString
    titleOfSale?: TranslatedString
    numberObjectInSale?: TranslatedString
    seller?: string
    institution?: string
    dateOldAffiliations?: DateOldAffiliationResource[]
    periodOldAffiations?: PeriodEventResource[]
    notes?: TranslatedString[]
}

interface DateOldAffiliationResource {
    date?: SkinDate
    dateQualifier?: string
}

interface PeriodEventResource {
    period?: string
    qualifier?: string
}

interface OldDepositoryResource {
    depository?: string
    date?: SkinDate 
    precision?: TranslatedString
}

interface DisappearanceDateResource {
    date?: SkinDate
    precision?: TranslatedString
}

interface RecoverDateResource {
    date?: SkinDate
    precision?: TranslatedString
}

interface RightItemResource {
    rightsStatus: string
    rightHolders?: string[]
    rightsCollectors?: string[]
    rightDates?: RightDateResource[]
    propertyRights?: string[]
    transfertRightItems?: TransfertRightItemResource[]
    loanRulesItems?: LoanRulesItemResource[]
    mention?: TranslatedString
    notes?: TranslatedString[]
    contractType?: string
}

interface RightDateResource {
    date?: SkinDate 
    qualifier?: string
}

interface TransfertRightItemResource {
    total: number
    currency?: string
    precision?: TranslatedString
}

interface LoanRulesItemResource {
    usageRules?: string
    precision?: TranslatedString
}

interface ItemSellingPriceResource {
    amount?: number
    currency?: string
    itemSellingPriceDates?: ItemSellingPriceDateResource[]
    precision?: TranslatedString
}

interface ItemSellingPriceDateResource {
    date?: SkinDate
    dateQualifier?: string
}

interface InformationOnDeaccessioningResource {
    deaccessionDate?: SkinDate
    disposalDate?: SkinDate
    disposalReason?: TranslatedString
    disposalMethod?: TranslatedString[]
    precision?: TranslatedString
    scientificCommissionOpinion?: TranslatedString
    notes?: TranslatedString[]
    internalManagerItems?: InternalManagerItemResource[]
}

interface InternalManagerItemResource {
    name?: string
    function?: string
    precision?: TranslatedString
}

interface SubInventoryRegisterResource {
    title?: TranslatedString
    volume?: TranslatedString
    numberOfItems?: TranslatedString
    furtherInformation?: TranslatedString
    notes?: TranslatedString[]
}

interface TaxationItemResource {
    amountTaxRebate?: number
    currency?: string
    taxReceiptRequested?: boolean
    date?: SkinDate
    precision?: TranslatedString
}

interface SourceReferenceItemResource {
    mentionType?: TranslatedString
    mention?: TranslatedString
}

export interface ActualContainerItem {
    container?: string, // ref to item
    precision?: TranslatedString, 
    date?: SkinDate,
}

export interface OwnerInstitutionResource {
    ownerInstitution?: string // ref to alias
    precision?: TranslatedString
}

export interface ContextualNotesSchemaResourceComplex {
    note?: TranslatedString | null
    tag?: TranslatedString | null 
}